"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Text = {
    variants: {
        subtitle: {
            fontWeight: 'medium',
        },
        title: {
            fontSize: '3xl',
            fontWeight: 'semibold',
        },
        muted: {
            color: 'gray.500',
        },
    },
};
exports.default = Text;
